import React, {useContext, useMemo} from "react";
import CategoryGrid from "@_components/category-grid";
import hasContainer from "@root/helpers/has-container";
import {CategoryContext} from "@root/context/category";

const CategoryGridModule = ({ data }) => {
    const { baseCategory, pageData } = useContext(CategoryContext) || {};

    // If we have a base category ( which is dynamically loaded from PMS ) we want to
    // use the subcategories otherwise we want to use the items from the CMS
    const categoryItems = useMemo(() => {
        if (baseCategory && baseCategory.subcategories) {
            return baseCategory?.subcategories?.map((category) => {
                return {
                    title: category.name,
                    slug: category.slug,
                    image: category.image_url,
                    subtitle: `${category.product_count} Products`,
                    url: pageData?.handle.current ? `${pageData?.handle.current}/${category.slug}` : category.slug,
                };
            });
        }
        return data?.items;
    }, [baseCategory, data]);

    if (!data || !categoryItems) return null;
    return (
        <div className={`${hasContainer(data?.moduleSettings?.hasContainer) !== "container" ? "p-0" : "container"}`}>
            <div className="patio-landing-page__title">
                <h2>{data.title}</h2>
            </div>
            <CategoryGrid items={categoryItems} />
        </div>
        
    );
};

export default CategoryGridModule;
